import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import VoucherService from "../../../../services/reservations/VoucherService";

export const REQUEST_FETCH_VOUCHER_INFORMATION =
  "REQUEST_FETCH_VOUCHER_INFORMATION";
export const FETCH_VOUCHER_INFORMATION_SUCCESS =
  "FETCH_VOUCHER_INFORMATION_SUCCESS";
export const FETCH_VOUCHER_INFORMATION_ERROR =
  "FETCH_VOUCHER_INFORMATION_ERROR";
export const INITIAL_STATE_VOUCHER_INFORMATION =
  "INITIAL_STATE_VOUCHER_INFORMATION";

function requestFetchVoucherInformation() {
  return {
    type: REQUEST_FETCH_VOUCHER_INFORMATION,
  };
}

function fetchVoucherInformationSuccess(json) {
  return {
    type: FETCH_VOUCHER_INFORMATION_SUCCESS,
    voucherInformation: json.data,
    message: json.message,
  };
}

function fetchVoucherInformationError(json) {
  return {
    type: FETCH_VOUCHER_INFORMATION_ERROR,
    error: json.data,
  };
}

export function initialStateVoucherInformation() {
  return {
    type: INITIAL_STATE_VOUCHER_INFORMATION,
  };
}

export function fetchVoucherInformacion(cruise_id, voucher_id) {
  return (dispatch) => {
    dispatch(requestFetchVoucherInformation());
    return VoucherService.getInformationVoucherPDF(cruise_id, voucher_id).then(
      (json) => {
        if (json.data.code === 200) {
          dispatch(fetchVoucherInformationSuccess(json.data, json.message));
        } else if (json.data.code === 202) {
          updateLocalStorageToken(json.data.token);
          dispatch(fetchVoucherInformacion(cruise_id, voucher_id));
        } else if (json.data.code === 498) {
          logOut();
        } else {
          dispatch(fetchVoucherInformationError(json.data));
        }
      }
    );
  };
}
